<template>
	<component
		:is="menuComponent"
		:is-open="isOpen"
		:menu-items="menuItems"
		:title="menuTitle"
		:hide-icon="hideIcon"
		:selected="selected"
		v-bind="customBindings"
		@close="close"
		@item-click="handleMenuItemClick"
	/>
</template>

<script>
import bus from '@videotools/js/events';
import MenuItemHandlerMixin from './MenuItemHandlerMixin';
import GridContextMenuMobile from './GridContextMenuMobile';
import EventTagContextMenuMobile from './EventTagContextMenuMobile';
import ListContextMenuMobile from './ListContextMenuMobile';
import MOBILE_MENU_TYPES from './constants';
import EventTagBulkContextMenuMobile from './EventTagBulkContextMenuMobile';
import VideoSettingsContextMenuMobile from './VideoSettingsContextMenuMobile';

export default {
	name:       'ContextMenuMobile',
	components: {
		GridContextMenuMobile,
		ListContextMenuMobile,
		EventTagContextMenuMobile,
		EventTagBulkContextMenuMobile,
		VideoSettingsContextMenuMobile,
	},
	mixins: [MenuItemHandlerMixin],
	data() {
		return {
			isOpen:           false,
			menuItems:        [],
			menuTitle:        '',
			menuIsHorizontal: false,
			onClose:          null,
			onItemSelected:   null,
			menuType:         'list',
			contextData:      null,
			selected:         null,
			hideIcon:         false,
		};
	},
	computed: {
		contextMenuListStyle() {
			if (this.isOpen || this.forceOpen) {
				return {
					display: 'block',
					opacity: '1',
					...this.position,
				};
			}
			return {
				opacity: '0',
				display: 'none',
			};
		},
		menuComponent() {
			switch (this.menuType) {
			case MOBILE_MENU_TYPES.eventTag:
				return EventTagContextMenuMobile;
			case MOBILE_MENU_TYPES.eventTagBulk:
				return EventTagBulkContextMenuMobile;
			case MOBILE_MENU_TYPES.grid:
			case MOBILE_MENU_TYPES.video:
				return GridContextMenuMobile;
			case MOBILE_MENU_TYPES.videoSettings:
				return VideoSettingsContextMenuMobile;
			case MOBILE_MENU_TYPES.list:
			default:
				return ListContextMenuMobile;
			}
		},
		customBindings() {
			switch (this.menuType) {
			case MOBILE_MENU_TYPES.eventTag:
				return { eventTag: this.contextData };
			case MOBILE_MENU_TYPES.eventTagBulk:
				return {
					eventTags: this.contextData.selected,
					total:     this.contextData.total,
				};
			default:
				return { contextData: this.contextData };
			}
		},
	},
	watch: {
		forceOpen(value) {
			if (!value) {
				this.isOpen = false;
			}
		},
	},
	mounted() {
		bus.subscribe('context-menu-mobile:close', this.close);
		bus.subscribe('context-menu-mobile:open', this.handleOpen);

		this.menuItems = this.items;
		this.menuTitle = this.modalTitle;
		this.menuIsHorizontal = this.isHorizontal;
	},
	beforeDestroy() {
		bus.unsubscribe('context-menu-mobile:close', this.close);
		bus.unsubscribe('context-menu-mobile:open', this.handleOpen);
	},
	methods: {
		toggleContextMenu(itemId) {
			this.isOpen = !this.isOpen;
			this.$emit('context-menu-opened', itemId);
		},
		open() {
			this.isOpen = true;
		},
		close() {
			if (this.isOpen) {
				this.isOpen = false;
				if (this.onClose) {
					this.onClose();
					this.onClose = null;
				}
				this.$emit('close-context-menu');
			}
		},
		init(props) {
			if (props) {
				const {
					menuType,
					menuItems,
					contextData,
					title,
					onClose,
					onItemSelected,
					selected,
					hideIcon,
				} = props;

				this.menuType = menuType;
				this.menuItems = menuItems;
				this.menuTitle = title || '';
				this.contextData = contextData;
				this.onClose = onClose;
				this.onItemSelected = onItemSelected;
				this.selected = selected;
				this.hideIcon = hideIcon;
			}
		},
		handleOpen(props) {
			this.init(props);
			this.open();
		},
	},
};
</script>

<style lang="scss" scoped>

</style>
